/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const QualitativeSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#EBE3FF" />
    <rect x="3" y="8" width="8" height="1" fill="#8E77CA" />
    <rect x="13" y="8" width="7" height="1" fill="#8E77CA" />
    <rect x="17" y="11" width="3" height="1" fill="#8E77CA" />
    <rect x="3" y="11" width="12" height="1" fill="#8E77CA" />
    <rect x="3" y="14" width="17" height="1" fill="#8E77CA" />
  </svg>
)

const QualitativeIcon = (props) => (
  <Icon component={QualitativeSvg} {...props} />
)

export { QualitativeIcon }
